import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HelpComponent } from './help.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'help', component: HelpComponent
      }
    ])
  ],
  declarations: [],
  exports: [RouterModule]
})
export class HelpRoutingModule { }
